export default "__VITE_ASSET__mpJZmY6V__"